<template>
  <div id="app">
    <Header></Header>
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  mounted() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.$api.get({
        url: "categories",
        success: (res) => {
          this.$store.commit("setcatelist", res.data.list.reverse());
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
